<template>
  <div>
    <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
        @click="goBack"
      ></el-button>
    <div
      style="
        width: 100%;
        text-align: center;
        font-size: 25px;
        font-weight: bold;
      "
    >
      校史馆参观预约
    </div>
    <div style="justify-content: center">
      <div
        v-if="getUserId"
        style="
          margin-top: 30px;
          justify-content: center;
          margin-left: 5%;
          margin-right: 5%;
          border: 1px solid #a0cc97;
          border-top: none;
        "
      >
        <el-row justify="center" align="middle" style="">
          <el-col :span="2">
            <div class="trcol">预约人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusername }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserid }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserdepartname }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">
              {{ userInfo.amusermajor != null ? userInfo.amusermajor : " " }}
            </div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">
              {{ userInfo.amuserclass != null ? userInfo.amuserclass : " " }}
            </div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">手机号码</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusertel }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="form" v-loading="loading">
        <el-form ref="form" :model="form" :rules="rules" label-width="130px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="单位名称：" prop="applydepname">
                <el-input v-model="form.applydepname"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="参观人姓名："
                prop="applyusers"
                placeholder="如果有多人参观请将参观人姓名均填上！"
              >
                <el-input v-model="form.applyusers"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="参观日期：" prop="visittime">
                    <el-date-picker
                      v-model="form.visittime"
                      type="datetime"
                      placeholder="选择日期时间"
                      default-time="9:00:00"
                      @change="pickervalue"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="参观人数：" prop="visitpeoples">
                    <el-input-number
                      v-model="form.visitpeoples"
                      :step="1"
                      :step-strictly="false"
                      :min="1"
                      :max="15"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="接待部门：" prop="recepdepcode">
                    <el-select
                      v-model="form.recepdepcode"
                      clearable
                      filterable
                      placeholder="请选择接待部门"
                      style="width: 100%"
                      @change="changeDept"
                    >
                      <el-option
                        v-for="item in depart"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="接待人：" prop="recepusername">
                    <!-- <el-select v-model="form.recepuserid" clearable filterable placeholder="请选择反馈类型"
                                        :remote-method="remoteMethod" style="width: 100%" :disabled="recepuseriddisabled" @change="changeType">
                                            <el-option v-for="item in options" :label="item.label" :value="item"
                                                :key="item.value"></el-option>
                                        </el-select> -->
                    <!-- <el-select v-model="form.recepuserid" filterable placeholder="请选择" remote
                                            :remote-method="remoteMethod" :disabled="recepuseriddisabled"
                                            style="width: 80%">
                                            <el-option v-for="item in recepuserlist" :key="item.userid"
                                                :label="item.username + '/' + item.userid" :value="item.userid" />
                                        </el-select> -->
                    <el-input v-model="form.recepusername"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人：" prop="applyusername">
                <el-input v-model="form.applyusername"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="getUserId">
              <el-form-item label="联系人电话：" prop="applyusertel">
                <el-input v-model="form.applyusertel" maxlength="11"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-else>
            <el-form-item label="联系人电话："  prop="applyusertel">
              <el-input v-model="form.applyusertel" maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="!getUserId">
            <el-button
              type="success"
              plain
              size="small"
              style="height:40px;margin-left:10px"
              @click="getAuthCode()"
              :disabled="!isSend"
            >{{sendTitle}}</el-button>
          </el-col>
          <el-col :span="5" v-if="!getUserId">
            <el-form-item label="验证码：">
              <el-input v-model="authCode" placeholder="请输入验证码" />
            </el-form-item>
          </el-col>
            <el-col :span="24">
              <el-form-item label="备注说明：" prop="memo">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入具体情况描述"
                  v-model="form.memo"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="邀请函/受邀凭证：" prop="pics">
                <el-row>
                  <el-upload
                    ref="upload"
                    :action="uploadPath"
                    :before-upload="beforeAvatarUpload"
                    :data="uploadSettings"
                    :headers="headers"
                    list-type="picture-card"
                    name="Fdata"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog
                    append-to-body
                    title="图片详情"
                    :visible.sync="dialogVisible"
                  >
                    <img alt="" :src="dialogImageUrl" width="100%" />
                  </el-dialog>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item style="align-items: center; text-align: center">
                <el-button class="submitClass" @click="onSubmit('form')"
                  >提交</el-button
                >
                <el-button class="colseClass" @click="goBack">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
  
<script>
// import moment from 'moment'
import { Message } from "element-ui";
import debounce from "lodash/debounce";
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import { searchDepart, byorgidgetuserinfo, save } from "@/api/SHMReservat";
import { sendMsg } from "@/api/serviceInfo.js";
import { queryMatter, queryRunById } from "@/api/matter.js";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  getAuthCode,
  checkAuthCode
} from "@/api/supplier.js";
export default {
  data() {
    //校验手机号
    const validatePhone = (rule, value, callback) => {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      recepuseriddisabled: true,
      depart: [],
      options: [],
      recepuserlist: [],
      value2: [],
      userInfo: {
        amuserid: "",
        amusername: "",
        amusertel: "",
        amuserdepartcode: "",
        amuserdepartname: "",
        amusermajor: "",
        amusergrade: "",
        amuserclass: "",
      },
      form: {
        id: "",
        applydepname: "",
        applydepcode: "",
        applyusers: "",
        visittime: "",
        visitpeoples: "",
        recepdepcode: "",
        recepdepname: "",
        recepuserid: "",
        recepusername: "",
        applyuserid: "",
        applyusername: "",
        applyusertel: "",
        memo: "",
        pics: "",
        handlestate: 1,       
      },
      isSend: true,
      sendTitle: "获取验证码",
      authCode:'',
      authCodeKey:"",
      rules: {
        applydepname: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        applyusers: [
          { required: true, message: "请输入参观人姓名", trigger: "blur" },
        ],
        visittime: [
          { required: true, message: "请选择参观日期", trigger: "blur" },
        ],
        recepdepcode: [
          { required: true, message: "请选择接待部门", trigger: "blur" },
        ],
        recepusername: [
          { required: true, message: "请选择接待人", trigger: "blur" },
        ],
        applyusername: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        applyusertel: [
          { required: true, message: "请输入联系人电话", trigger: "change" },
          { validator: validatePhone, trigger: "change" }
        ],
      },
      colStyWidth: "0px",
      types: [],
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      uploadSettings: {
        uploadUrl: "",
        packageName: "/img",
        templateUrl: " ",
        queueLimit: 10,
        fileTypes: ["*"],
        limitSize: 2,
      },
      headers: {
        appkey: "XKES",
      },
      centerArr: [],
      srcList: [],
      playStatus: "",
      muteStatus: "",
      isMute: true,
      isPlay: false,
      width: "60", // 设置视频播放器的显示宽度（以像素为单位）
      height: "60", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: "",
      totalTime: 60, //一般是60
      timer: "", //定时器
    };
  },
  computed: {
    ...mapGetters(["getUserId", "getUserInfo"]),
  },
  mounted() {
    let user = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log(user);
    if (this.getUserId) {
      this.userInfo = {
        amuserid: user.userid,
        amusername: user.name,
        amusertel: user.mobile,
        amuserdepartcode: "",
        amuserdepartname: user.department,
        amusermajor: user.major,
        amusergrade: user.grade,
        amuserclass: user.bj,
      };
    }else{
      this.userInfo = {
        amuserid: '20230001',
        // amusername: '校外人员',
        // amusertel: user.mobile,
        // amuserdepartcode: "",
        // amuserdepartname: user.department,
        // amusermajor: user.major,
        // amusergrade: user.grade,
        // amuserclass: user.bj,
      };
    }

    // this.userId = window.sessionStorage.getItem("userId");
    // this.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"))
    // console.log(this.userInfo);
    // this.form.feedUser = this.userInfo.name
    // this.form.feedUserid = this.userInfo.bh
    this.getDept();
  },
  methods: {
    //获取验证码功能
    async getAuthCode() {
      if (!this.form.applyusertel) {
        Message.error("请填写手机号后获取验证码！");
      } else if (/^1(3|4|5|6|7|8)\d{9}$/.test(this.form.applyusertel) == false) {
        Message.error("请填写正确的手机号后获取验证码！");
      } else {
        this.isSend = false;
        this.sendTitle = this.totalTime + "s后重新发送";
        let data = await getAuthCode(this.form.applyusertel);
           if (data != null && data != undefined && data.msg == "repeated") {
          this.$message({
            message: "提示:该手机号一分钟内已经申请过，请一分钟后重试!",
            type: "warning"
          });
        }else if(data != null && data != undefined ){
          this.$store.commit('setToken',data.data.fwdtAdmin)
        sessionStorage.setItem("xzztcToken", data.data.fwdtService);
        this.authCodeKey = data.msg;
        }
        this.timer = setInterval(() => {
          this.totalTime--;
          this.sendTitle = this.totalTime + "s后重新发送";
          if (this.totalTime < 0) {
            clearInterval(this.timer);
            this.sendTitle = "重新发送验证码";
            this.totalTime = 60;
            this.isSend = true;
          }
        }, 1000);
      }
    },
    remoteMethod: debounce(function (query) {
      console.log(query);
      byorgidgetuserinfo(this.form.recepdepcode, query).then((res) => {
        console.log(res.data);
        this.recepuserlist = res.data;
      });
    }, 300),
    formatTime(n) {
      //判断是否需要加0
      if (n < 10) {
        return "0" + n;
      } else {
        return n;
      }
    },
    pickervalue() {
      var date = new Date();
      // var year = this.formatTime(date.getFullYear());
      // var month = this.formatTime(date.getMonth() + 1);
      // var day = this.formatTime(date.getDate());
      // console.log(day, "1111111111111111");
      // var timex = `${year}-${month}-${day + 1}` + " 00:00:00";
      var timestamp1 = moment(date).format("YYYY-MM-DD");
      console.log(timestamp1);
      var time = this.form.visittime;
      var timestamp2 = moment(time).format("YYYY-MM-DD");
      if (timestamp2 <= timestamp1) {
        Message({
          message:
            "预约时间不能小于" +
            moment(date).format("YYYY-MM-DD") +
            ",请重新选择时间！",
          type: "warning",
        });
        this.form.visittime = "";
      }
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      const isList = ["image/jpeg", "image/png", "image/bmp"];
      if (isList.indexOf(file.type) == -1) {
        this.$message.error("上传头像图片只能是 JPG,png,bmp格式!");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        Message({
          message: "文件大小不能超过 10MB!",
          type: "warning",
        });
        return false;
      }
    },
    handleAvatarSuccess(res) {
      console.log(res);
      this.srcList.push(this.fileAcquisition + res.object.url);
      this.centerArr.push({
        name: res.object.originalName,
        type: res.object.type,
        originalUrl: res.object.url,
        url: this.fileAcquisition + res.object.url,
      });
      this.form.pics = this.centerArr;
      console.log(this.centerArr);
    },
    // 删除文件
    handleRemove(file) {
      console.log(this.centerArr,file);
      let indexa = "";
      this.centerArr.forEach((item, index) => {
        if (item.originalUrl == file.response.object.url) {
          indexa = index;
        }
      });
      this.centerArr.splice(indexa, 1);
      this.form.pics = this.centerArr;
      console.log(this.form.pics);
    },
    async changeDept() {
      console.log(this.form.recepdepcode);
      this.recepuseriddisabled = false;
      this.remoteMethod();
    },
    changeType() {
      this.form.feedTypeid = this.form.feedType.value;
      this.form.feedType = this.form.feedType.label;
    },
    onSubmit(form) {
      // if (this.form.pics.length < this.form.visitpeoples) {
      //     Message({
      //         message: '上传健康码或行程码数量与参观人数不符合！',
      //         type: 'warning',
      //     })
      //     return
      // }
      var that = this;
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          console.log(!this.getUserId);
          if(!this.getUserId){
            let auth = await checkAuthCode(this.authCodeKey,this.authCode);
          if (auth.msgCode !== 0) {
            this.$message({
              message: "验证码错误！",
              type: "error"
            });
            this.authCode=''
            this.loading = false;
            return;
          }
          }       
          this.form.pics = JSON.stringify(this.form.pics);
          this.depart.forEach((item) => {
            if (item.id == this.form.recepdepcode) {
              this.form.recepdepname = item.text;
            }
          });
          // this.recepuserlist.forEach((item) => {
          //     if (item.userid == this.form.recepuserid) {
          //         this.form.recepusername = item.username;
          //     }
          // })
          var formdata = { ...this.form, ...this.userInfo };
          console.log(formdata);
          const data = await save(formdata);
          console.log(data);
          if (data.msgCode == 0) {
            if(this.getUserId){
            let params = {
              id: data.data.id + "-2", //事项id
              receiveUser: data.data.amuserid, //接收者userId
              memo:
                "您在" +
                moment(data.data.createtime).format("YYYY年MM月DD日HH点mm分") +
                "申请了【校史馆参观预约】，系统正在办理中，请耐心等待！", //消息内容
              sendUser: data.data.amuserid, //发送者userId
              serviceId: "1575738395629727746", //服务id
              f4: "校史馆参观预约",
            };
            console.log(params);
            sendMsg(params).then((res) => {
              console.log(res);
            });            
          }
          console.log(data.data.f1);
          await queryRunById(data.data.f1).then((res1) => {
              queryMatter(res1.data.f4).then((res2) => {
                if (res2.code == 0) {
                  let params1 = {
                    id: data.data.id + "-1", //事项id
                    receiveUser: res2.data[0].assigneeUser.id, //接收者userId
                    memo: "您收到一个【校史馆参观预约】的待处理事项，请及时处理！", //消息内容
                    sendUser: data.data.amuserid, //发送者userId
                    serviceId: "1575738395629727746", //服务id
                    f4: "校史馆参观预约",
                  };
                  sendMsg(params1).then((res) => {
                    console.log(res);
                  });
                }
              });
            });
            this.$confirm(
              "您的预约已成功提交，我们会尽快受理您的预约，请及时查询微信消息通知关注预约处理进度，如有其他疑问请拨打该咨询电话：027-0999199231",
              "系统提示",
              {
                confirmButtonText: "返回主页",
                cancelButtonText: "继续预约",
                type: "success",
                center: true,
                showClose: false,
                callback: (action, instance) => {
                  console.log(action);
                  console.log(instance);
                  // 返回主页
                  if (action == "confirm") {
                    that.$router.push("/serviceHome");
                  }
                  // 继续反馈
                  if (action == "cancel") {
                    this.centerArr = [];
                    this.$refs["form"].resetFields();
                    this.$refs["upload"].clearFiles();
                    clearInterval(this.timer);
                    this.sendTitle = "获取验证码";
                    this.isSend = true;
                    this.totalTime = 60;
                    this.authCode=''
                  }
                },
                closeOnClickModal: false,
                closeOnPressEscape: false,
                cancelButtonClass: "cancelButtonClass",
                confirmButtonClass: "confirmButtonClass",
              }
            )
              .then(() => {
                that.from = {
                  id: "",
                  applydepname: "",
                  applydepcode: "",
                  applyusers: "",
                  visittime: "",
                  visitpeoples: "",
                  recepdepcode: "",
                  recepdepname: "",
                  recepuserid: "",
                  recepusername: "",
                  applyuserid: "",
                  applyusername: "",
                  applyusertel: "",
                  memo: "",
                  pics: "",
                  handlestate: 1,
                };
                console.log(that.form);
              })
              .catch(() => {});
          }
          this.loading = false;
        }
      });
    },
    updatathis() {},
    async getDept() {
      const data = await searchDepart();
      console.log(data);
      this.depart = data.data;
    },
    getType() {},
    goBack() {
      this.$router.push("/serviceHome");
    },
  },
};
</script>
  
<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-bottom: none;
}
.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-bottom: none;
}
.form {
  margin-left: 5%;
  border: 1px solid #dddddd;
  margin-top: 30px;
  padding: 20px;
  margin-right: 5%;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}
.avatar {
  width: 100px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}
.close {
  position: absolute;
  right: 0;
  font-size: 20px;
}
.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: white;
}
.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
  background-color: #008a2c;
}
.el-message-box {
  border: 2px solid #008a2c;
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  font-size: 18px;
  box-shadow: 0 2px 12px 0rgba (0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.el-message-box--center .el-message-box__header {
  padding-top: 15px;
}
.colseClass {
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
.colseClass:hover,
.colseClass:focus {
  /* padding: 9px 15px; */
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}
.submitClass,
.submitClass:focus {
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}
.submitClass:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}
.cancelButtonClass {
  padding: 9px 15px;
  font-size: 12px;
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}
.cancelButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}
.confirmButtonClass,
.confirmButtonClass:focus {
  padding: 9px 15px;
  font-size: 12px;
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
.confirmButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}
</style>